/**
*
* Loader
*
*/

import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import LoadingImg from '../../assets/images/loading.gif';
// import { prependOnceListener } from 'cluster';

const Styledloader = styled.div`
    background: rgba(255, 255, 255, 0.93);
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    margin: 0 auto;
    top:0;
    span{
      width:50px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-right: -50%;
      transform: translate(-50%,-50%)
    }
    img{
      /* width:50px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-right: -50%;
      transform: translate(-50%,-50%) */
    }
    ${({ type }) => {
    if (type === 'half') {
      return css`
        background:${(props) => props.theme.transparentColor};
        position:static;
        width:auto;
        height:auto;
        text-align:center;
        img{
          width:50px !important;
          margin: 0;
          position: static;
          top: 50%;
          left: 50%;
          margin-right: 0;
          transform: inherit;
        }
      `;
    }
    return '';
  }}
`;

function Loader(props) {
  const { type } = props;
  return (
    <Styledloader type={type}>
      {/* <img src={LoadingImg} alt="" width="50px" style={{ marginRight: '-50%', transform: 'translate(-50%,-50%)' }} /> */}
      <span style={{ width: '50px', position: 'absolute', top: '50%', left: '50%', marginRight: ' -50%', transform: 'translate(-50%,-50%)' }}><img src={LoadingImg} alt="" width="50px" /></span>
    </Styledloader>
  );
}

Loader.propTypes = {
  type: PropTypes.string,
};

export default Loader;



// WEBPACK FOOTER //
// client/components/Loader/index.js